import { TPaymentCardResponse } from "../../../../../api";

export const isPendingCardStatus = (status: TPaymentCardResponse | undefined) => {
  return status === "NEW" || status === "PENDING" || status === "OTP_REQUIRED" || status === "WAITING_FOR_ACTIVATION";
};

export const isPollingStatus = (status: TPaymentCardResponse | undefined) => {
  return status === "NEW" || status === "PENDING" || status === "OTP_REQUIRED" || status === "WAITING_FOR_ACTIVATION";
};
